module.exports = __webpack_public_path__ + "assets/media/mike_face.26dc4c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/LolaTestimonial/mike_face.png
// module id = 1993
// module chunks = 0